import * as Yup from 'yup';

export function riderProfileSchema(shouldValidateInvoiceGroup: boolean) {
  return Yup.object().shape({
    firstName: Yup.string().required('Required Field'),
    lastName: Yup.string().required('Required Field'),
    dateOfBirth: Yup.date().typeError('Required Field'),
    gender: Yup.string().required('Required Field'),
    category: Yup.string().nullable().required('Required Field'),
    email: Yup.string().email(),
    photosAttributes: Yup.array().of(
      Yup.object().shape({
        attachment: Yup.mixed().test('fileSize', 'The file is too large', (value) => {
          if (!value?.length) {
            return true;
          }

          return value[0].size <= 10000000;
        }),
      })
    ),
    invoiceGroupId: shouldValidateInvoiceGroup
      ? Yup.number().nullable().required('Required Field')
      : Yup.number().nullable(),
  });
}
